module.exports = __webpack_public_path__ + "media/images/clipboard-d7a8e2922506c888b53d5d36830e6c1a.svg";